import styled from 'styled-components';
import Input from 'components/Input';
import Picklist from 'components/Picklist';
import {
    DIVIDER, GREY_400, WHITE,
} from '../../../../constants';

export const Container = styled.div`
    display: flex;
    gap: 0.5rem;
    align-items: flex-start;
    box-sizing: border-box;
    align-self: stretch;
    padding: 0.5rem;
    border-radius: 0.5rem;
    background: ${WHITE};
`;

export const InputElements = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    flex: 1;
`;

export const StyledInput = styled(Input)`
    flex: 1;
    label {
        margin-left: 0;
        font-size: 0.8125rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    input {
        border-radius: 0.375rem;
        border: 1px solid ${DIVIDER};

        ::placeholder {
            font-weight: 300 !important;
            font-size: 0.75rem;
        }
    }

    label + div > span {
        color: ${GREY_400};
        width: 1.5rem;
        flex-shrink: 0;
        
        svg {
            width: 1.5rem !important;
            height: 1.5rem !important;
            font-size: 1.5rem !important;
        }        
    }

    div[id^="error-message"] {
        align-self: flex-start;
    }
`;

export const StyledPicklist = styled(Picklist)`
    width: fit-content;
    input {
        border: medium;
        background: ${DIVIDER};
        border: 1px solid transparent;
        user-select: none;

        border-radius: 0.375rem;
        
        ::placeholder {
            font-weight: 300 !important;
        }

        :focus,
        :active,
        :hover {
            background: ${DIVIDER};
        }
    }
`;
